import { B2CPartnerManagementImpl } from "../data/B2CPartnerManagementImpl";
import { IB2CPartnerManagementRepository } from "../domain/repositories/IB2CPartnerManagementRepository";
import { B2CPartnerManagementUseCase } from "../domain/useCases/B2CPartnerManagementUseCase";
import { B2CPartnerManagementViewModel } from "../presentation/viewModel/B2CPartnerManagementViewModel";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class PartnerManagementInjection extends InjectionModule {
  private static readonly b2cPartnerManagementRepositoryToken = Symbol(
    "IB2CPartnerManagementRepository",
  );
  private static readonly b2cPartnerManagementUseCaseToken = Symbol(
    "B2CPartnerManagementUseCase",
  );
  private static readonly b2cPartnerManagementViewModelToken = Symbol(
    "B2CPartnerManagementViewModel",
  );

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.b2cPartnerManagementRepositoryToken,
      useClass: B2CPartnerManagementImpl,
    },
    {
      scope: "otherRepo",
      token: this.b2cPartnerManagementUseCaseToken,
      useClass: B2CPartnerManagementUseCase,
    },
    {
      scope: "viewModel",
      token: this.b2cPartnerManagementViewModelToken,
      useClass: B2CPartnerManagementViewModel,
    },
  ];

  static getB2CRepo(): IB2CPartnerManagementRepository {
    return this.resolve(this.b2cPartnerManagementRepositoryToken);
  }

  static getB2CUseCase(): B2CPartnerManagementUseCase {
    return this.resolve(this.b2cPartnerManagementUseCaseToken);
  }
}
